module.exports = __webpack_public_path__ + "static/media/banner3.774b0b15.jpg";